import { useState } from 'react'

import { MINUTE } from '../constants/date'
import { createDate } from '../utils/date'

import { useSchedule } from './useSchedule'
import { useTimeZone } from './useTimeZone'
import { useVariableRef } from './useVariableRef'

/**
 * The {@link useDate} hook returns the current date.
 *
 * @usage
 * ```
 *  const date = useDate(timeout)
 * ```
 *
 * @param {number} [timeout] - Refresh timeout. One minute by default.
 *
 * @returns {Date}
 */
export function useDate(timeout = MINUTE) {
  const timeZone = useTimeZone()
  const timezoneRef = useVariableRef(timeZone)

  const [currentDate, setCurrentDate] = useState(() => createDate(timeZone))
  const [prevTimeZone, setPrevTimeZone] = useState(timeZone)

  // Refresh the date when the timezone changes — during render.
  if (timeZone !== prevTimeZone) {
    setPrevTimeZone(timeZone)
    setCurrentDate(() => createDate(timeZone))
  }

  useSchedule(timeout, () => {
    setCurrentDate(createDate(timezoneRef.current))
  })

  return currentDate
}
